// Static ports of the controls in CONTROL_TEMPLATE_PORTS (contract §8.3).
// Until a port draws a look within the pixel comparison with renderControl,
// it answers null and the panel keeps its `<tc-face>` page, which is today's
// drawing by construction.

/** A static port of the panel, or null when no port draws this look. */
export function controlPort() {
  return null;
}
